import { useMemo, useState } from 'react';

const useToggle = (initialState = false) => {
  const [state, setState] = useState(initialState);

  const handlers = useMemo(
    () => ({
      on: () => {
        setState(true);
      },
      off: () => {
        setState(false);
      },
      switch: () => {
        setState(!state);
      },
    }),
    [state]
  );

  return [state, handlers.on, handlers.off, handlers.switch];
};

export default useToggle;
